import Vue from 'vue'
import Parse from 'parse'
// models
import {
    Applicant,
    ApplicantVM,
} from '@/models/applicant'
import {
    Employer,
    EmployerVM,
} from '@/models/employer'
import {
    Announcement,
    AnnouncementVM,
} from '@/models/announcement'
import {
    Notification,
    NotificationVM,
} from '@/models/notification'

var models = {
    applicants: [Applicant, ApplicantVM],
    employers: [Employer, EmployerVM],
    announcements: [Announcement, AnnouncementVM],
    notifications: [Notification, NotificationVM],
};

function generate_api_module(api, name, model, model_vm) {
    api[name] = {};
    Vue.set(api[name], 'data', []);
    var sync_handlers = [];
    var call_sync_handlers = function() {
        sync_handlers.forEach(function(handler) {
            Vue.set(handler[0], handler[1], api[name].data);
        });
    };
    var update_data = function(instance, use_sync_handlers) {
        if (instance.objectId) {
            var index = _.findIndex(api[name].data, function(obj) {
                return obj.objectId === instance.objectId;
            });
            if (index !== -1) {
                // or Vue.set
                api[name].data[index] = instance;
                if (use_sync_handlers || use_sync_handlers === undefined) {
                    call_sync_handlers();
                }
                return true;
            }
        }
        return false;
    };
    var remove_data = function(id) {
        var index = _.findIndex(api[name].data, function(obj) {
            return obj.objectId === id;
        });
        if (index !== -1) {
            api[name].data.splice(index, 1);
            return true;
        }
        return false;
    };
    api[name].sync = function(vm, name) {
        sync_handlers.push([vm, name]);
        // unsync
        return function() {
            var index = _.findIndex(sync_handlers, function(handler) {
                return handler[0] === vm && handler[1] === name;
            });
            if (index !== -1) {
                sync_handlers.splice(index, 1);
            }
        };
    };
    api[name].create = function(id) {
        return model_vm(id);
    };
    api[name].query = function() {
        var query = new Parse.Query(model);
        return query;
    };
    api[name].load = function(query) {
        var replace_data = (query) ? false : true;
        if (!query) {
            query = new Parse.Query(model);
        }
        return query.find().then(function(results) {
            results = results.map(model_vm);
            if (replace_data) {
                // api[name].data = results;
                Vue.set(api[name], 'data', results);
                call_sync_handlers();
                return api[name].data;
            } else {
                // update data
                var updated_any = false;
                results.forEach(function(result) {
                    var updated = update_data(result, false);
                    if (!updated_any && updated) {
                        updated_any = true;
                    }
                });
                if (updated_any) {
                    call_sync_handlers();
                }
                return results;
            }
        });
    };
    api[name].remove = function(instance_or_id) {
        if (typeof(instance_or_id) === 'string') {
            var instance = model.createWithoutData(instance_or_id);
            return instance.destroy().then(function() {
                if (remove_data(instance_or_id)) {
                    call_sync_handlers();
                }
                return undefined;
            });
        } else {
            var id = instance_or_id.objectId;
            return instance_or_id.$p.destroy().then(function() {
                if (remove_data(id)) {
                    call_sync_handlers();
                }
                return undefined;
            });
        }
    };
    api[name].save = function(instance) {
        return instance.$save().then(function() {
            //update_data(instance);

            // TODO: is this the right approach?
            if (!update_data(instance)) {
                api[name].data.push(instance);
                call_sync_handlers();
            }
            return instance;
        });
    };
    api[name].get = function(instance_or_id, force_fetch) {
        if (typeof(instance_or_id) === 'string') {
            if (!force_fetch) {
                var index = _.findIndex(api[name].data, function(obj) {
                    return obj.objectId === instance_or_id;
                });
                if (index !== -1) {
                    var promise = new Parse.Promise();
                    promise.resolve(api[name].data[index]);
                    return promise;
                }
            }

            var instance = model_vm(instance_or_id);
            return instance.$fetch().then(function() {
                if (update_data(instance)) {
                    call_sync_handlers();
                }
                return instance;
            });
        } else {
            if (force_fetch) {
                return instance_or_id.$fetch().then(function() {
                    if (update_data(instance_or_id)) {
                        call_sync_handlers();
                    }
                    return instance_or_id;
                });
            } else {
                var promise = new Parse.Promise();
                promise.resolve(instance_or_id);
                return promise;
            }
        }
    };
    api[name].pointer = function(id) {
        return model.createWithoutData(id);
    };
}

function API() {
    for (var k in models) {
        generate_api_module(this, k, models[k][0], models[k][1]);
    }
    this.user = function() {
        return Parse.User.current();
    };
}

const api = new API();

export default api;




// WEBPACK FOOTER //
// ./src/api/index.js